var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWinzLetter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 256,
  height: 216
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 921",
  fill: "#f7fafc",
  d: "M0 0h256v216H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 125",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 24.5h66"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 134",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M173.5 24.5h66"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 126",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 34.5h66"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 127",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 44.5h66"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 128",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 69.5h223"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 129",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 79.5h223"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 130",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 89.5h223"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 131",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 99.5h223"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 132",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 109.5h223"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 135",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 139.5h223"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 136",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 149.5h223"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 137",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 159.5h223"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 139",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 189.5h223"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 140",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 199.5h223"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 141",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 209.5h223"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 138",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 169.5h173"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 133",
  fill: "none",
  stroke: "#7d8286",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.5 119.5h78"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 129",
  d: "M206.5 14.87s-34.2.135-42.086 4.693-3.055 9.1 10.532 13.538 24.881 6.255 43.813 4.205 27.835-5.747 31.913-12.4-4.71-8.767-17.127-13.063-35.444-1.667-35.444-1.667",
  fill: "none",
  stroke: "#bc7133"
})));
export { SvgWinzLetter as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='256' height='216' viewBox='0 0 256 216'%3e %3cg id='winz-letter' transform='translate(-1173 -1609)'%3e %3crect id='Rectangle_921' data-name='Rectangle 921' width='256' height='216' transform='translate(1173 1609)' fill='%23f7fafc'/%3e %3cline id='Line_125' data-name='Line 125' x2='66' transform='translate(1189.5 1633.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_134' data-name='Line 134' x2='66' transform='translate(1346.5 1633.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_126' data-name='Line 126' x2='66' transform='translate(1189.5 1643.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_127' data-name='Line 127' x2='66' transform='translate(1189.5 1653.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_128' data-name='Line 128' x2='223' transform='translate(1189.5 1678.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_129' data-name='Line 129' x2='223' transform='translate(1189.5 1688.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_130' data-name='Line 130' x2='223' transform='translate(1189.5 1698.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_131' data-name='Line 131' x2='223' transform='translate(1189.5 1708.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_132' data-name='Line 132' x2='223' transform='translate(1189.5 1718.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_135' data-name='Line 135' x2='223' transform='translate(1189.5 1748.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_136' data-name='Line 136' x2='223' transform='translate(1189.5 1758.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_137' data-name='Line 137' x2='223' transform='translate(1189.5 1768.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_139' data-name='Line 139' x2='223' transform='translate(1189.5 1798.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_140' data-name='Line 140' x2='223' transform='translate(1189.5 1808.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_141' data-name='Line 141' x2='223' transform='translate(1189.5 1818.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_138' data-name='Line 138' x2='173' transform='translate(1189.5 1778.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Line_133' data-name='Line 133' x2='78' transform='translate(1189.5 1728.5)' fill='none' stroke='%237d8286' stroke-linecap='round' stroke-width='3'/%3e %3cpath id='Path_129' data-name='Path 129' d='M8038.5-275.13s-34.2.135-42.086,4.693-3.055,9.1,10.532,13.538,24.881,6.255,43.813,4.205,27.835-5.747,31.913-12.4-4.71-8.767-17.127-13.063-35.444-1.667-35.444-1.667' transform='translate(-6659 1899)' fill='none' stroke='%23bc7133' stroke-width='1'/%3e %3c/g%3e %3c/svg%3e";